import { gql } from '@apollo/client';

// Parent-session query: lands in the parent app's own isolated ApolloClient cache
// (see "Parent/staff cache isolation" in CLAUDE.md) — no extra bookkeeping needed.
export const GET_PARENT_PLAYERS = gql`
  query GetParentPlayers {
    parentPlayers {
      normalizedName
      displayName
      players {
        _id
        code
        firstName
        lastName
        nickname
        company {
          _id
          name
        }
        contact {
          _id
          name
          email
          phone
          relationship
        }
        assessments {
          _id
          code
          assessmentName
          ageGroupName
          year
          reportCardDataId
        }
      }
    }
  }
`;

// Parent's verified-credentials view. See "Parent OTP auth — one mutation pair"
// in CLAUDE.md for the wider auth model.
export const GET_PARENT_SELF = gql`
  query GetParentSelf {
    parentSelf {
      _id
      name
      emails
      phones
    }
  }
`;

// Flat list of every PlayerContact this parent owns — drives the per-player
// email/SMS-override editor on the account page.
export const GET_PARENT_PLAYER_CONTACTS = gql`
  query GetParentPlayerContacts {
    parentPlayerContacts {
      _id
      playerId
      name
      email
      phone
      relationship
      sportInvolvement
      playerName
      companyName
      sport
      otherContacts {
        _id
        name
        email
        phone
        relationship
      }
    }
  }
`;

// Other parent accounts holding players that share a credential with this one.
// Credentials come back masked; the raw address never crosses the wire.
export const GET_PARENT_ACCOUNT_CONFLICTS = gql`
  query GetParentAccountConflicts {
    parentAccountConflicts {
      _id
      playerCount
      credentials {
        key
        channel
        masked
      }
      players {
        _id
        name
        companyName
      }
    }
  }
`;
